module.exports = __webpack_public_path__ + "img/zhangjiagang-station.2b4c544d.jpg";